import { useState } from "react";

import { isTapToPaySupportedByCountry } from "@simplyk/common";

import { useCurrentUserContext } from "@/common/contexts/CurrentUserContext";

export type CheckInAccordionKey = "zeffyApp" | "webCheckIn" | "printGuestList";

export const CHECK_IN_ACCORDION_EXPAND_ACTIONS = {
  zeffyApp: "expand_zeffy_app",
  webCheckIn: "expand_web_check_in",
  printGuestList: "expand_print_guest_list",
} as const satisfies Record<CheckInAccordionKey, string>;

const DEFAULT_OPEN_ACCORDIONS: Record<CheckInAccordionKey, boolean> = {
  zeffyApp: true,
  webCheckIn: false,
  printGuestList: false,
};

export const useCheckInToolsDrawer = ({
  onAccordionExpand,
}: {
  onAccordionExpand?: (accordionKey: CheckInAccordionKey) => void;
} = {}) => {
  const { organization } = useCurrentUserContext();
  const isTapToPaySupported = isTapToPaySupportedByCountry(organization?.country);
  const [openAccordions, setOpenAccordions] = useState(DEFAULT_OPEN_ACCORDIONS);

  const toggleAccordion = (accordionKey: CheckInAccordionKey) => {
    if (!openAccordions[accordionKey]) {
      onAccordionExpand?.(accordionKey);
    }
    setOpenAccordions((previous) => ({ ...previous, [accordionKey]: !previous[accordionKey] }));
  };

  return { isTapToPaySupported, openAccordions, toggleAccordion };
};
